// SGC mobile "Xem thêm / Rút gọn" toggle for the product news section.
// New component specific to SGC — no default equivalent.
import { Body, CustomLink, styled } from '@teko/ds-mobile';
import React from 'react';

interface SeeMoreProps {
  // href -> link (new tab); otherwise a toggle button.
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

// Shared "Xem thêm" for the description & news blocks (mobile SGC).
export const SeeMore: React.FC<SeeMoreProps> = ({ href, onClick, children }) =>
  href ? (
    <SeeMoreLink href={href} target="_blank">
      <Body level={1} color="primary">
        {children}
      </Body>
    </SeeMoreLink>
  ) : (
    <SeeMoreButton type="button" onClick={onClick}>
      <Body level={1} color="primary">
        {children}
      </Body>
    </SeeMoreButton>
  );

const baseStyle = `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: pointer;
`;

const SeeMoreLink = styled(CustomLink)`
  ${baseStyle}
  padding: 16px 24px;
`;

const SeeMoreButton = styled.button`
  ${baseStyle}
  padding: 12px;
  background: transparent;
  border: none;
  font: inherit;
`;
